export default __webpack_public_path__ + "static/media/arrow-up-small-white.26fb9617.svg";